export function spliterSlider() {
    let splitSlider = $(".image-spliter");
    splitSlider.each(function () {
        let $this = $(this);
        let slider = $this.find(".image-slider");
        let foregroundImg = $this.find(".foreground-img");
        let $mover = $this.find(".mover");
        slider.on("input change", function (e) {
            let sliderPos = e.target.value;
            foregroundImg.css("width", sliderPos + "%");
            $mover.css("left", sliderPos + "%");
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/spliterSlider.js